export type PaymentIntentClientAction =
    | "confirm_existing"
    | "confirm_with_payment_method"
    | "return_to_account"
    | "wait";

export function getPaymentIntentClientAction(
    status?: string,
    hasClientSecret = false
): PaymentIntentClientAction {
    const normalized = status?.trim().toLowerCase();
    if (normalized === "requires_payment_method") return "confirm_with_payment_method";
    if (normalized === "requires_action" || normalized === "requires_confirmation") {
        return "confirm_existing";
    }
    if (normalized === "processing" || normalized === "succeeded") return "return_to_account";
    // Older API versions returned a client secret without the PaymentIntent
    // status. Confirming that intent as-is keeps a frontend-first rollout safe.
    if (!normalized && hasClientSecret) return "confirm_existing";
    return "wait";
}
